"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssuesToDoViews = void 0;
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const ViewFieldKey_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldKey"));
const ViewFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldRegistry"));
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const App_1 = __importDefault(require("@opsbase/lib-system/App"));
const View_1 = __importDefault(require("../View"));
exports.IssuesToDoViews = [
    new View_1.default({
        apps: [App_1.default.OPSBASE],
        id: DataType_1.default.ISSUE_TODO,
        type: DataType_1.default.ISSUE_TODO,
        autoRefresh: 60 * 2,
        fields: [
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.TITLE],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.PLACE],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_STATUS],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_FLAG],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_ASSIGNEDTO],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_OCCURRENCE],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_TYPE],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.ISSUE_ASSET],
        ],
        filters: [
            {
                queryFieldKey: QueryFieldKey_1.default.SHOW_MINE_ONLY,
                id: 'TRUE',
                title: 'Show Only Mine',
                hidden: true,
                veryHidden: true,
            },
        ],
        groupBys: [],
    }),
];
exports.default = exports.IssuesToDoViews;
